<template lang="pug">
  div
    v-alert.mb-3(v-if="!hasTags" dense text type="info" icon="fas fa-info-circle") {{ $t('dashboardPage.noBoarderGroupTags') }}
    v-simple-table.tag-table(dense)
      template(v-slot:default)
        thead
          tr
            th.text-left
            th.text-center(v-for="slot in slots" :key="slot.menuGroupSlotId")
              div.grey--text.text--darken-1.caption {{ slot.menuGroupTitle }}
              div.font-weight-bold {{ slot.code }}
        tbody
          tr(v-for="row in visibleRows" :key="rowKey(row)")
            td.text-left.font-weight-bold
              v-icon.mr-2(small v-if="row.tag && row.tag.iconClass") {{ tagIcon(row.tag.iconClass) }}
              span(:class="{'grey--text': !row.tag}") {{ rowTitle(row) }}
            td.text-center.text-h6(v-for="cell in row.menuGroupSlotSummary" :key="cell.menuGroupSlotId" :class="{'grey--text text--lighten-1': !cell.portionsCount}") {{ cell.portionsCount }}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import MenuGroupSummary from '@/model/MenuGroupSummary'
import {BoarderGroupTagSlotSummaryResponse, BoarderGroupTagSummaryResponse} from '@/types/service-response'
import {tagIconClass} from '@/services/tagIcon'

/**
 * "Po skupinách" tab of the order overview: portions of the selected day per
 * boarder-group tag (e.g. school stupeň), one column per menu-group slot.
 * Fed from the same reservation-summary response as the per-slot tab; the
 * parent (DashboardReservationSummary) owns title, date, polling and the
 * "no menu" state.
 */
@Component
export default class DashboardBoarderGroupTagSummary extends Vue {
  @Prop({type: Array, required: true}) readonly summaryData!: MenuGroupSummary[]

  get rows (): BoarderGroupTagSummaryResponse[] {
    const summary = this.summaryData && this.summaryData[0]

    return summary ? summary.boarderGroupTagSummary || [] : []
  }

  get hasTags (): boolean {
    return this.rows.some(row => !!row.tag)
  }

  /** The unassigned row is shown only while it has portions (or when it is the only row, i.e. no tags configured yet). */
  get visibleRows (): BoarderGroupTagSummaryResponse[] {
    return this.rows.filter(row => row.tag || row.totalPortionsCount > 0 || !this.hasTags)
  }

  /** Columns, taken from the first row — every row carries the same slots in the same order. */
  get slots (): BoarderGroupTagSlotSummaryResponse[] {
    return this.rows.length ? this.rows[0].menuGroupSlotSummary : []
  }

  rowKey (row: BoarderGroupTagSummaryResponse): string {
    return row.tag ? `tag-${row.tag.id}` : 'unassigned'
  }

  rowTitle (row: BoarderGroupTagSummaryResponse): string {
    return row.tag ? row.tag.title : this.$t('dashboardPage.unassignedBoarderGroupTag').toString()
  }

  tagIcon (iconClass: string | null): string {
    return tagIconClass(iconClass)
  }
}
</script>

<style lang="stylus" scoped>
.tag-table
  background-color white
  border-radius 15px
  >>> th, >>> td
    white-space nowrap
</style>
